import {MyopBindMessage, MyopBindReplayMessage} from "./BaseMessage";
import {MyopMessageKey} from "../common/MyopMessages";

const ReplayMessageKey = 'CleanupReplayMessage'

export class CleanupMessage extends MyopBindMessage<void, CleanupReplayMessage> {
    replyMessageKey: MyopMessageKey = ReplayMessageKey
    messageType = 'CleanupMessage';

    constructor(public cleanupForMessageId: string, handler: (message: CleanupReplayMessage) => void) {
        super(handler);
    }
}

export class CleanupReplayMessage extends MyopBindReplayMessage {
    messageType = ReplayMessageKey

    constructor(public customCleanup: boolean) {
        super();
    }
}
